"use client"
import { useEffect, useRef, useState } from "react"
import Link from "next/link"
import clsx from "clsx"
import { HeaderLink } from "./constants"
import { HomeIcon } from "@/components/icons"


interface HomeNavProps {
  homeLinks: HeaderLink[]
}

export const HomeNav = ({ homeLinks }: HomeNavProps) => {
  const [showHomeNav, setShowHomeNav] = useState(false)
  const dropdownRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setShowHomeNav(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  return (
    <div ref={dropdownRef} className="relative flex justify-center items-center ml-[30px]">
      <button
        aria-label="home-nav"
        onClick={() => setShowHomeNav(!showHomeNav)}
        className="p-2 rounded-full hover:bg-white/10 transition cursor-pointer"
      >
        <HomeIcon />
      </button>

      <div
        className={clsx(
          "absolute top-15 right-0 mt-3 w-56 rounded-xl shadow-lg overflow-hidden transition-all duration-300 transform",
          showHomeNav
            ? "opacity-100 translate-y-0 bg-[#161E2D]/50 backdrop-blur-sm"
            : "opacity-0 -translate-y-2 pointer-events-none"
        )}
      >
        {homeLinks.map((link, i) => (
          <Link
            key={i}
            href={link?.href ?? "#"}
            className="block px-4 py-3 hover:bg-white/10 transition"
            onClick={() => setShowHomeNav(false)}
          >
            {link.label}
          </Link>
        ))}
      </div>
    </div>
  )
}
